export default "__VITE_ASSET__DslSDEUq__"